interface CommitFlowParams {
  isDirty: boolean;
  recipeId: string;
  currentEtag: string;
  body: string;
  tags: string[];
  trainingConfig: Record<string, unknown>;
  commitNotes: string | null;
  updateMutateAsync: (args: {
    recipeId: string;
    input: {
      expected_etag: string;
      body: string;
      tags: string[];
      training_config: Record<string, unknown>;
    };
  }) => Promise<{ etag: string; recipeId: string }>;
  commitMutateAsync: (args: {
    recipeId: string;
    input: { expected_etag: string; notes: string | null };
  }) => Promise<unknown>;
}

export async function commitWithDirtyState(params: CommitFlowParams): Promise<void> {
  let etagForCommit = params.currentEtag;

  if (params.isDirty) {
    const updateResult = await params.updateMutateAsync({
      recipeId: params.recipeId,
      input: {
        expected_etag: params.currentEtag,
        body: params.body,
        tags: params.tags,
        training_config: params.trainingConfig,
      },
    });
    etagForCommit = updateResult.etag;
  }

  await params.commitMutateAsync({
    recipeId: params.recipeId,
    input: {
      expected_etag: etagForCommit,
      notes: params.commitNotes,
    },
  });
}
